import { Controller } from "@hotwired/stimulus"

/**
 * Stories Bar controller — handles opening the viewer from
 * the horizontal stories circle bar.
 */
export default class extends Controller {
  static targets = ["container"]
  static values = {
    viewerType: String,
    viewerId: Number,
  }

  openViewer(event) {
    const storyIds = String(event.params.storyIds)
    const overlay = document.getElementById("story-viewer-overlay")
    if (!overlay) return

    const viewer = this.application.getControllerForElementAndIdentifier(
      overlay, "story-viewer"
    )
    if (viewer) {
      viewer.openWithStories(storyIds)
    }
  }
}
